"use client";

import React from "react";
import { Send, Loader } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GetInTouch() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}
function ContactForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center space-y-4 py-12 text-center">
        <div className="bg-primary/10 text-primary flex size-16 items-center justify-center rounded-full">
          <Send className="size-8" />
        </div>
        <h3 className="text-2xl font-bold text-foreground">Message Sent!</h3>
        <p className="text-muted-foreground max-w-md">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="mt-4 rounded-xl">
          Send Another Message
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <FormField control={control} name="name" rules={{
        required: "Name is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Your Name</FormLabel>
              <FormControl>
                <Input placeholder="Jane Doe" className="rounded-xl" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email address"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Email Address</FormLabel>
              <FormControl>
                <Input type="email" placeholder="jane@example.com" className="rounded-xl" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="phone" render={({
      field
    }) => <FormItem>
            <FormLabel>
              Phone Number <span className="text-muted-foreground text-xs font-normal">(Optional)</span>
            </FormLabel>
            <FormControl>
              <Input type="tel" placeholder="+1 (555) 123‑4567" className="rounded-xl" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "Message is required"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Message</FormLabel>
            <FormControl>
              <Textarea placeholder="How can we help you?" className="min-h-[150px] rounded-xl resize-y" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="bg-destructive/10 text-destructive rounded-xl p-4 text-sm">
          {submitError}
        </div>}

      <div className="flex justify-center pt-4">
        <Button type="submit" disabled={isSubmitting} size="lg" className="w-full md:w-auto min-w-[200px] rounded-xl font-semibold">
          {isSubmitting ? <>
              <Loader className="mr-2 size-4 animate-spin" />
              Sending...
            </> : "Send Message"}
        </Button>
      </div>
    </Form>;
}